import React, { Component } from 'react'

export default class About extends Component {
    render() {
        return (
            <div>
                {/* white spaces at the top of the page */}
                <div className="colorlib-narrow-content">
                    <div className="row col-xs-12 col-md-4"><p></p></div>
                    <div className="row col-xs-12 col-md-4"><p></p></div>
                    <div className="row col-xs-12 col-md-4"><p></p></div>
                </div>
                <div className="colorlib-narrow-content">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="row row-bottom-padded-sm animate-box" data-animate-effect="fadeInLeft">
                                <div className="col-md-12">
                                    <div className="about-desc">
                                        <span className="heading-meta">About Me</span>
                                        <h2 className="colorlib-heading">Lihao?</h2>
                                        <p>
                                            Hi! My name is Lihao Zhu, a current CIS Master's student @UPenn graduating in 2022.
                                            I received bachelor's degree from Lehigh University and won the Donald J. Hillman Memorial Award, which awards to a senior with outstanding achievement on AI topics.
                                            My focus gradually shift from ML to Software Development after join UPenn, and I am comfortable writing C++, Java and Python program.
                                        </p>
                                        <p>
                                            I joined LinkedIn as a Software Engineer Intern for this summer.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
